'use client'
import React, {useContext} from "react"
import {
  Box,
  Paper,
  Button,
  useTheme,
  Typography,
  useMediaQuery,
  Card, CardMedia,
} from "@mui/material"
import {GLOBAL_PATHS} from "@/lib/globals"
import {TranslationContext} from "@/configs/context"


/**
 * Ce composant est un call to action de la page
 * @constructor
 */
const CtaMobile: React.FC = () => {
  const theme = useTheme()
  // @ts-ignore
  const { t }: object = useContext(TranslationContext)
  const matchMd = useMediaQuery(theme.breakpoints.up('md'))

  const cardWidth = "17rem" // screenSize.width*0.7
  const cardHeight = "27.5rem" // screenSize.height*0.65
  const cardSx = {
    mr: 2,
    border: 0,
    borderRadius: 3,
    width: cardWidth,
    height: cardHeight,
    whiteSpace: "normal",
    display: "inline-block",
  }
  const mobileBoxSx = {
    overflowX: "auto",
    whiteSpace: "nowrap",
    width: `calc(100% - 32px)`,
    // width: screenSize.width - 32,
  }

  return (
    <Box id="cta-section">
      <Box className="no-scrollbar" sx={{ ...mobileBoxSx }}>
        {[
          {
            label: "cta-vcard3",
            path: `${GLOBAL_PATHS.COVERS}vcard3.webp`,
          },
          {
            label: "cta-vcard2",
            path: `${GLOBAL_PATHS.COVERS}vcard2.webp`,
          },
          {
            label: "cta-vcard4",
            path: `${GLOBAL_PATHS.COVERS}vcard4.webp`,
          },
          {
            label: "cta-vcard5",
            path: `${GLOBAL_PATHS.COVERS}vcard5.webp`,
          },
        ].map((item) => (
          <Card key={item.label} elevation={0} variant="elevation" sx={cardSx}>
            <CardMedia
              alt=""
              component="img"
              image={item.path}
              sx={{ width: cardWidth, height: cardHeight }}
            />
          </Card>
        ))}
      </Box>
      <Paper
        elevation={0}
        sx={{ p: 2, mt: 2, textAlign: "center" }}
      >
        <Box>
          <Typography variant={matchMd ? "h3" : "h4"} sx={{ fontWeight: "bold" }}>
            {t('translation:cta.title')}
          </Typography>
          <Typography variant={matchMd ? "h6" : "body1"} sx={{ marginTop: "0.5rem" }}>
            {t('translation:cta.content')}
          </Typography>
          <Button
            size="large"
            variant="black-glass"
            href="#contact-section"
            sx={{ mt: 3, py: 2, px: 4 }}
          >
            {t('translation:cta.action')}
          </Button>
        </Box>
      </Paper>
    </Box>
  )
}

export default CtaMobile
